import * as React from 'react'
import { HybridSettingsPageResourceType } from './HybridSettingsPageResourceType'

export type Props = {
  option: any,
  ellipsis: string,
}

export const HybridSettingsPageResourceContainer = (props: Props) => {
  return (
    <div className={'opt-container'}>
      <div className={`opt-label-container ${props.ellipsis}`}>
        <span>{props.option.label}</span>
      </div>
      <HybridSettingsPageResourceType option={props.option}/>
    </div>
  )
}
